import React from 'react'

import AboutDevelopersCard from '../AboutDevelopersCard'
import { DevelopersArea, DevelopersList } from './style'
import { useAboutDevelopersList } from './useAboutDevelopersList'

const AboutDevelopersList = () => {
    const { developers } = useAboutDevelopersList()

    return (
        <DevelopersArea>
            <DevelopersList>
                {developers.map((developer) => (
                    <AboutDevelopersCard
                        key={developer.id}
                        developer={developer}
                    />
                ))}
            </DevelopersList>
        </DevelopersArea>
    )
}

export default AboutDevelopersList
